module.exports = __webpack_public_path__ + "media/images/vr/games/azura/azura-header-f53c5a6196a3301e752870762bb4e031.jpg";